import { useState, useEffect } from "react";
import productService from "services/product-service";

import { CircularProgress } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { PieChart } from "@mui/x-charts/PieChart";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { valueFormatter, qtyFormatter } from "./webUsageStats";
import { desktopOS } from './webUsageStats';



export default function StockDiversity({
    organization
}) {
    const [stockDiversity, setStockDiversity] = useState([]);
    const [isVisible, setIsVisible] = useState(true);
    const [tabValue, setTabValue] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [productsByQty, setProductsByQty] = useState([]);
    const [productsByPrice, setProductsByPrice] = useState([]);

    // Fetch stock diversity data
    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const orgId = organization ? organization.id : undefined;
                console.log("Fetching product diversity for organization:", organization);
                const response = await productService.getProductDiversity(orgId);
                setProductsByQty(response.data);
                setProductsByPrice(response.monetary);
            } catch (error) {
                console.error('Error fetching product diversity data:', error);
            } finally {
                setIsLoading(false);
            }
        })();
    }, [organization])
    // Handles the tab value
    const handleSetTabValue = (event, newValue) => {
        setTabValue(newValue);
    }
    return (
        <Card sx={{ width: "100%", overflow: "visible", height: "100%" }}>
            <MDBox display="flex">
                <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="4rem"
                    height="4rem"
                    variant="gradient"
                    bgColor="primary"
                    color="white"
                    shadow="md"
                    borderRadius="xl"
                    ml={3}
                    mt={-2}
                >
                    <Icon fontSize="medium" color="inherit">
                        leaderboard
                    </Icon>
                </MDBox>
                <MDTypography variant="h5" sx={{ mt: 2, mb: 1, ml: 2 }}>
                    Products Diversity
                </MDTypography>
            </MDBox>

            <MDBox mt={2} ml={2} mr={2}>
                <AppBar position="static">
                    <Tabs orientation="horizontal" value={tabValue} onChange={handleSetTabValue}>
                        <Tab
                            label="By Quantity"
                            icon={
                                <Icon fontSize="small" sx={{ mt: -0.25 }}>
                                    inventory_2
                                </Icon>
                            }
                        />
                        <Tab
                            label="By Value"
                            icon={
                                <Icon fontSize="small" sx={{ mt: -0.25 }}>
                                    attach_money
                                </Icon>
                            }
                        />
                    </Tabs>
                </AppBar>
            </MDBox>

            <MDBox p={2} display="flex" justifyContent="center" alignItems="center">
                {isLoading ? (
                    <MDBox
                        p={5}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                        height="100%" // Adjust this value based on your header height
                    >
                        <CircularProgress />
                    </MDBox>

                ) : (

                    <MDBox
                        p={2}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: 'calc(100% - 150px)' // Adjust this value based on your header height
                        }}
                    >
                        {isVisible && (
                            <>
                                {tabValue === 0 && (
                                    <PieChart
                                        series={[
                                            {
                                                data: productsByQty,
                                                highlightScope: { fade: 'global', highlight: 'item' },
                                                faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                                                qtyFormatter,
                                                cx: 200,
                                            },
                                        ]}
                                        width={400}
                                        height={400}
                                        slotProps={{
                                            legend: {
                                                hidden: true,
                                            },
                                        }}
                                    />

                                )}
                                {tabValue === 1 && (
                                    <PieChart
                                        series={[
                                            {
                                                data: productsByPrice,
                                                highlightScope: { fade: 'global', highlight: 'item' },
                                                faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                                                valueFormatter,
                                                cx: 200,
                                            },
                                        ]}
                                        width={400}
                                        height={400}
                                        slotProps={{
                                            legend: {
                                                hidden: true,
                                            },
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </MDBox>)}

            </MDBox>
        </Card>
    );
}